import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackNoteGenerationFailedSpec,
  trackOfflineRecordingDeletedSpec,
  trackOfflineRecordingQueuedSpec,
  trackOfflineRecordingStartedSpec,
  trackOfflineSyncCompletedSpec,
  trackOfflineSyncFailedSpec,
  type NoteGenerationFailed,
  type OfflineRecordingDeleted,
  type OfflineRecordingQueued,
  type OfflineRecordingStarted,
  type OfflineSyncCompleted,
  type OfflineSyncFailed,
} from '@snowtype/snowplow';

import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const offlineRecordingEvents: SnowplowEventMap = {
  [TrackingEventName.OfflineRecordingStarted]: (props) =>
    trackOfflineRecordingStartedSpec(props as OfflineRecordingStarted),
  [TrackingEventName.OfflineRecordingQueued]: (props) =>
    trackOfflineRecordingQueuedSpec(props as OfflineRecordingQueued),
  [TrackingEventName.OfflineRecordingDeleted]: (props) =>
    trackOfflineRecordingDeletedSpec(props as OfflineRecordingDeleted),
  [TrackingEventName.OfflineSyncCompleted]: (props) =>
    trackOfflineSyncCompletedSpec(props as OfflineSyncCompleted),
  [TrackingEventName.OfflineSyncFailed]: (props) =>
    trackOfflineSyncFailedSpec(props as OfflineSyncFailed),
  [TrackingEventName.NoteGenerationFailed]: (props) =>
    trackNoteGenerationFailedSpec(props as NoteGenerationFailed),
};
